/**
 * Estimate Modal Controller
 *
 * Manages the estimate editing modal
 * @module portal/modules/ui/modals/estimateModal
 */

import { state } from '../../state';
import { els } from '../elements';

const bodyEl = document.body;

/**
 * Check if the estimate modal is currently open
 */
export function isEstimateModalOpen(): boolean {
  return !!els.estimateModal && !els.estimateModal.hidden;
}

/**
 * Close the estimate modal and clear edit state
 */
export function closeEstimateModal(): void {
  if (els.estimateModal) {
    els.estimateModal.hidden = true;
  }
  if (els.estimateModalBackdrop) {
    els.estimateModalBackdrop.hidden = true;
  }
  if (bodyEl) {
    bodyEl.classList.remove('modal-open');
  }

  state.estimateEdit = null;
}
